import nbaBg from "../styles/img/nba/nba-bg.jpg";
import nhlBg from "../styles/img/nhl/nhl-bg.jpg";
import soccerBg from "../styles/img/soccer/soccer-bg.jpg";
import mlbBg from "../styles/img/mlb/mlb-bg.jpg";
import nflBg from "../styles/img/nfl/nfl-bg.jpg";

import nflLogo from "../styles/img/nfl/nfl-logo.png";
import mlbLogo from "../styles/img/mlb/mlb-logo.png";
import nhlLogo from "../styles/img/nhl/nhl-logo.png";
import nbaLogo from "../styles/img/nba/nba-logo.png";
import cfbLogo from "../styles/img/cfb/cfb-logo.svg";
import cbbLogo from "../styles/img/cbb/cbb-logo.svg";
import soccerUefach from "../styles/img/soccer/uefach.svg";
import soccerUefal from "../styles/img/soccer/uefal.png";
import soccerUefaeq from "../styles/img/soccer/uefaeq.png";
import soccerFifa from "../styles/img/soccer/fifa.svg";
import soccerEpl from "../styles/img/soccer/epl.svg";
import soccerGbl from "../styles/img/soccer/gbl.svg";
import soccerSpd from "../styles/img/soccer/spd.svg";
import soccerAsa from "../styles/img/soccer/asa.png";
import soccerIsa from "../styles/img/soccer/isa.svg";
import soccerNed from "../styles/img/soccer/ned.svg";
import soccerMls from "../styles/img/soccer/mls.svg";
import soccerSaca from "../styles/img/soccer/saca.svg";
import soccerAcan from "../styles/img/soccer/acan.png";
import soccerLmx from "../styles/img/soccer/lmx.svg";
import soccerFl1 from "../styles/img/soccer/fl1.png";
import soccerRfpl from "../styles/img/soccer/rfpl.png";
import soccerBsa from "../styles/img/soccer/bsa.png";
import soccerConcacaf from "../styles/img/soccer/concacaf.svg";
import soccerAal from "../styles/img/soccer/aal.svg";
import soccerSacl from "../styles/img/soccer/sacl.svg";
import soccerSacs from "../styles/img/soccer/sacs.svg";
import soccerJps from "../styles/img/soccer/jps.png";
import soccerIsl from "../styles/img/soccer/isl.png";
import soccerIci from "../styles/img/soccer/ici.svg";
import soccerCwc from "../styles/img/soccer/cwc.svg";

const soccerObj = {
  "soccer-uefach": {
    logo: soccerUefach,
    bg: soccerBg,
  },
  "soccer-uefal": {
    logo: soccerUefal,
    bg: soccerBg,
  },
  "soccer-uefaeq": {
    logo: soccerUefaeq,
    bg: soccerBg,
  },
  "soccer-ech": {
    logo: soccerUefach,
    bg: soccerBg,
  },
  "soccer-fifawc": {
    logo: soccerFifa,
    bg: soccerBg,
  },
  "soccer-fifaf": {
    logo: soccerFifa,
    bg: soccerBg,
  },
  "soccer-epl": {
    logo: soccerEpl,
    bg: soccerBg,
  },
  "soccer-gbl": {
    logo: soccerGbl,
    bg: soccerBg,
  },
  "soccer-spd": {
    logo: soccerSpd,
    bg: soccerBg,
  },
  "soccer-asa": {
    logo: soccerAsa,
    bg: soccerBg,
  },
  "soccer-isa": {
    logo: soccerIsa,
    bg: soccerBg,
  },
  "soccer-ned": {
    logo: soccerNed,
    bg: soccerBg,
  },
  "soccer-mls": {
    logo: soccerMls,
    bg: soccerBg,
  },
  "soccer-saca": {
    logo: soccerSaca,
    bg: soccerBg,
  },
  "soccer-acan": {
    logo: soccerAcan,
    bg: soccerBg,
  },
  "soccer-lmx": {
    logo: soccerLmx,
    bg: soccerBg,
  },
  "soccer-fl1": {
    logo: soccerFl1,
    bg: soccerBg,
  },
  "soccer-rfpl": {
    logo: soccerRfpl,
    bg: soccerBg,
  },
  "soccer-bsa": {
    logo: soccerBsa,
    bg: soccerBg,
  },
  "soccer-concacaf": {
    logo: soccerConcacaf,
    bg: soccerBg,
  },
  "soccer-aal": {
    logo: soccerAal,
    bg: soccerBg,
  },
  "soccer-sacl": {
    logo: soccerSacl,
    bg: soccerBg,
  },
  "soccer-sacs": {
    logo: soccerSacs,
    bg: soccerBg,
  },
  "soccer-jps": {
    logo: soccerJps,
    bg: soccerBg,
  },
  "soccer-isl": {
    logo: soccerIsl,
    bg: soccerBg,
  },
  "soccer-ici": {
    logo: soccerIci,
    bg: soccerBg,
  },
  "soccer-cwc": {
    logo: soccerCwc,
    bg: soccerBg,
  },
};

const getImage = {
  ...soccerObj,
  nba: {
    logo: nbaLogo,
    bg: nbaBg,
  },
  nhl: {
    logo: nhlLogo,
    bg: nhlBg,
  },
  mlb: {
    logo: mlbLogo,
    bg: mlbBg,
  },
  nfl: {
    logo: nflLogo,
    bg: nflBg,
  },
  cfb: {
    logo: cfbLogo,
    bg: nflBg,
  },
  cbb: {
    logo: cbbLogo,
    bg: nbaBg,
  },
};

export default getImage;
